<style lang="scss" src='./SensorProvisioning.scss' scoped ></style>
<template src="./SensorProvisioning.html"></template>

<script>
import { mapState, mapMutations } from 'vuex';
import { getSensor, GetSensorRSSI, CleanUpSensor, MoveToInventory } from '@/api/api';
import ProvisioningStep1 from '@/views/sensor/provisioning/steps/step-1/ProvisioningStep1.vue';
import ProvisioningStep2 from '@/views/sensor/provisioning/steps/step-2/ProvisioningStep2.vue';
import ProvisioningStep3 from '@/views/sensor/provisioning/steps/step-3/ProvisioningStep3.vue';
import ProvisioningStep4 from '@/views/sensor/provisioning/steps/step-4/ProvisioningStep4.vue';
import ProvisioningStep5 from '@/views/sensor/provisioning/steps/step-5/ProvisioningStep5.vue';
import ProvisioningStep6 from '@/views/sensor/provisioning/steps/step-6/ProvisioningStep6.vue';
import ProvisioningStep7 from '@/views/sensor/provisioning/steps/step-7/ProvisioningStep7.vue';
import ProvisioningStep0 from '@/views/sensor/provisioning/steps/step-0/ProvisioningStep0.vue';
import ProvisioningStepFinal from '@/views/sensor/provisioning/steps/step-final/ProvisioningStepFinal.vue';
import CommonComponent from '@/components/utils/CommonComponent.vue';
import GwPassword from '@/components/gwPassword/GwPassword.vue';

const StepComponents = [
  ProvisioningStep1,
  ProvisioningStep2,
  ProvisioningStep3,
  ProvisioningStep4,
  ProvisioningStep5,
  ProvisioningStep6,
  ProvisioningStep7,
];

export default {
  name: 'SensorProvisioning',
  extends: CommonComponent,
  components: {
    ProvisioningStep0,
    ProvisioningStepFinal,
    ProvisioningStep1,
    ProvisioningStep2,
    ProvisioningStep3,
    ProvisioningStep4,
    ProvisioningStep5,
    ProvisioningStep6,
    ProvisioningStep7,
    GwPassword
  },
  data() {
    return ({
      sensor: null,
      stepComponents: StepComponents,
      totalSteps: 7,
      rssiInterval: null,
      password: null,
      loadingAbort: {
        cleaningSensor: false,
      },
      step6_continue: false,
    });
  },
  computed: {
    ...mapState('SensorProvisioning', {
      step: (state) => state.step,
      canBack: (state) => state.canBack,
      canContinue: (state) => state.canContinue,
      loading: (state) => state.loading,
      provisionPayload: (state) => state.provisionPayload,
    }),
    ...mapState('SensorList', {
      rssiRanges: (state) => state.rssiRanges,
    }),
  },

  methods: {
    
    async moveToInventory() {
      this.loadingAbort.cleaningSensor = true;
      await MoveToInventory(this.sensor.sensor_id).then( resetSensor => {
        this.$refs.modalLowRssi.hide()
        this.updateSensor(resetSensor);
        this.$router.go(-1);
      }).finally(() => {
        this.loadingAbort.cleaningSensor = false;
      });
    },

    getRssiIcon(sensor) {
      // eslint-disable-next-line
      return require(`@/assets/img/gw/sensor/${this.G_getRssiIcon(sensor, this.rssiRanges)}`);
    },

    checkRSSI() {
      this.rssiInterval = window.setInterval(this.getSensorRSSI, process.env.VUE_APP_REFRESH_DATA_TIME_MS);
    },

    getSensorRSSI() {
      getSensor(this.sensor.sensor_id).then((response) => {
        this.sensor.latitude = response.latitude;
        this.sensor.longitude = response.longitude;
      });
      GetSensorRSSI(this.sensor.sensor_id).then((response) => {
        if (this.$refs.modalLowRssi) {
          this.sensor.rssi = response.rssi;
          if (response.aceptable_signal) {
            this.$refs.modalLowRssi.hide();
          } else {
            this.$refs.modalLowRssi.show();
          }
        }
      });
    },

    async back() {
      if (await this.canBack()) {
        this.setStep(this.step - 1);
      }
    },

    async continues() {
      if (await this.canContinue()) {
        this.setStep(this.step + 1);
      }
    },

    async abortSensor(){
      if (this.password) {
        this.loadingAbort.cleaningSensor = true;
          await CleanUpSensor(this.sensor.sensor_id, this.password).then( sensorCleaned => {
            this.$bvModal.hide('md-clean-up-sensor');
            this.updateSensor(sensorCleaned);
            this.$router.go(-1);
          }).finally(() => {
            this.loadingAbort.cleaningSensor = false;
          });
        
      } else {
        this.$notify({ ignoreDuplicates: true, type: 'warn', text: this.$t('login.enterYourPassword'), });
      }
    },

    setStep6Continue(){
      this.step6_continue = true;
    },

    ...mapMutations('SensorProvisioning', ['setStep']),
    ...mapMutations('SensorList', ['updateSensor']),

  },

  beforeCreate() {},

  created() {},

  beforeMount() {
    this.setShowMenu(false);
    this.setShowBackground(false);
  },

  mounted() {
    this.sensor = this.$store.state.sensor;
    this.setStep(0);
    this.checkRSSI();
  },

  beforeDestroy() {
    window.clearInterval(this.rssiInterval);
  },
};
</script>
